<template>
		<div class="panel bgPanel mt1x cb mr1x ml1x" id="generateExcess">
				<div class="clearfix dateSys titleBar title-bg">
						<span class="fs14x" :title="getLanguageStr('word1474','自发自用历史')">{{getLanguageStr("word1474","自发自用历史")}}</span>
			<div class="fR dpIB_E vaM_E">
				<div class="cField tra-fast_E vaM_E posR" @mouseleave="leave">
					<button @mouseenter="paramChooiceShow" :title="getLanguageStr('word566','参数选择')" class="sizeS bdSub pl1x pr1x boxR hover-main">{{getLanguageStr('word566','参数选择')}}</button>
					<DeviceDetailParam ref="DeviceDetailParam" @selectArray="updateShowParamArray"  @beingParamArray="beingParamArray"></DeviceDetailParam>
				</div>
				<div class="cField tra-fast_E vaM_E hover-cMain_E">
					<button id="prevExcess" class="w2x fa fa-angle-left fs14x" type="button" :class="{disable:timeChoose[ActiveIndex].type ==='all'}" @click="dateChange('perv')"></button>
					<vue-datepicker-local v-if="timeChoose[ActiveIndex].type ==='all'" v-model="rangeDate" format="YYYY" :local="local" class="sizeS lh20" disabled></vue-datepicker-local>
					<vue-datepicker-local v-else v-model="time" :format="timeChoose[ActiveIndex].format" ref="date" :local="local" class="sizeS lh20" @input="_showChart()" :disabled-date="disabledDate"></vue-datepicker-local>
					<button id="nextExcess" class="w2x fa fa-angle-right fs14x" type="button" :class="{disable:timeChoose[ActiveIndex].type ==='all'||timeGetTime>=todayGetTime}" @click="dateChange('next')"></button>
				</div>
				<div class="classGroup cField_E bdSub_E tra-fast_E">
					<button type="button" :class="{active:ActiveIndex==index}" v-for="(item,index) in timeChoose" @click="_timePicker(item,index)" :key="index">{{item.datepicker}}</button>
				</div>
			</div>
				<!-- <div class="classGroup fR cb cField_E bdSub_E tra-fast_E">
								<button type="button" :class="{active:ActiveIndex==index}" v-for="(item,index) in timeChoose" @click="_timePicker(item,index)" :key="index">{{item.datepicker}}</button>
						</div>
						<div class="fR cField tra-fast_E vaM_E hover-cMain_E">
								<button id="prevExcess" class="w2x fa fa-angle-left fs14x" type="button" :class="{disable:timeChoose[ActiveIndex].type ==='all'}" @click="dateChange('perv')"></button>
								<vue-datepicker-local v-model="rangeDate" format="YYYY" v-if="timeChoose[ActiveIndex].type ==='all'" disabled  :local="local" class="datepicker"></vue-datepicker-local>
								<vue-datepicker-local v-model="time" :format="timeChoose[ActiveIndex].format" ref="date" v-else  :local="local" class="datepicker " @input="_showChart()" :disabled-date="disabledDate"></vue-datepicker-local>
								<button id="nextExcess" class="w2x fa fa-angle-right fs14x" type="button" :class="{disable:timeChoose[ActiveIndex].type ==='all'||timeGetTime==todayGetTime}" @click="dateChange('next')"></button>
						</div>
			<div class="fR cField tra-fast_E vaM_E hover-cMain_E posR">
				<button @click="paramChooiceShow" :title="getLanguageStr('word566','参数选择')" class="cSub bdSub pl1x pr1x sizeS curP">{{getLanguageStr('word566','参数选择')}}</button>
				<DeviceDetailParam ref="DeviceDetailParam" @selectArray="updateShowParamArray"></DeviceDetailParam>
			</div> -->
				</div>
				<div class="emptyToken_EE posR"  style="min-height:3.2em">
			<loading ref="Loading"></loading>
			<div class="dpIB_E taC tableSys" v-if="JSON.stringify(detailData) !='{}'">
				<div class="w49pct" v-if="metering.consumeProportionStatisticMethod !='THEORY'">
					<div class="progressWrap w80pct">
						<div>
							<span v-if="ActiveIndex==0" :title="$t('word358',['当日发电量'])">{{$t("word358",["当日发电量"])+':&nbsp;'}}</span>
							<span v-if="ActiveIndex==1" :title="$t('word359',['当月发电量'])">{{$t("word359",["当月发电量"])+":&nbsp;"}}</span>
							<!-- <span v-if="ActiveIndex==2" :title="getLanguageStr('plant290','当季发电量')">{{getLanguageStr('plant290','当季发电量')+':&nbsp;'}}</span> -->
							<span v-if="ActiveIndex==2" :title="$t('word360',['当年发电量'])">{{$t("word360",["当年发电量"])+":&nbsp;"}}</span>
							<span v-if="ActiveIndex==3" :title="$t('word912',['总发电量'])">{{$t("word912",["总发电量"])+":&nbsp;"}}</span>
							<span v-if="detailData.statistics" :title="convertData(detailData.statistics.generationValue,2,'k','Wh')[0]">{{ convertData(detailData.statistics.generationValue,2,"k",'Wh')[0]}}</span>
							<span v-else>--</span>
						</div>
						<div class="progress mt05x">
							<div class="fL h10 bgPrimary transWidth" :style="{width:proportion.toConsumptionProportion+'%'}">
							</div>
							<div class="fR h10 bgSuccess transWidth" :style="{width:proportion.toGridProportion+'%'}">
							</div>
						</div>
						<div class="cb">
							<div class="fL textL">
								<span v-if="detailData.statistics" class="cPrimary" :title="floatFix(detailData.statistics.generationRatio,2,'%')">{{floatFix(detailData.statistics.generationRatio,2,'%')}}</span>
								<span v-else>--</span><br>
								<span :title="$t('word1760',['用于自用'])">{{$t('word1760',['用于自用'])}}</span><br>
								<span v-if="detailData.statistics" :title="convertData(detailData.statistics.generationValue*detailData.statistics.generationRatio/100,2,'k','Wh')[0]">{{convertData(detailData.statistics.generationValue*detailData.statistics.generationRatio/100,2,"k","Wh")[0]}}</span>
								<span v-else>--</span>
							</div>
							<div class="fR textR">
								<span v-if="detailData.statistics" class="cSuccess" :title="floatFix(detailData.statistics.gridRatio,2,'%')">{{floatFix(detailData.statistics.gridRatio,2,'%')}}</span>
								<span v-else>--</span><br>
								<span :title="$t('word1762',['用于并网'])">{{$t('word1762',['用于并网'])}}</span><br>
								<span v-if="detailData.statistics" :title="convertData(detailData.statistics.generationValue*detailData.statistics.gridRatio/100,2,'k','Wh')[0]">{{convertData(detailData.statistics.generationValue*detailData.statistics.gridRatio/100,2,"k","Wh")[0]}}</span>
								<span v-else>--</span>
							</div>
						</div>
					</div>
				</div>
				<div class="w49pct" v-if="metering.consumeProportionStatisticMethod !='THEORY'">
					<div class="progressWrap w80pct">
						<div>
							<span v-if="ActiveIndex==0" :title="$t('word527',['当日用电量'])">{{$t("word527",["当日用电量"])+":&nbsp;"}}</span>
							<span v-if="ActiveIndex==1" :title="$t('word528',['当月用电量'])">{{$t("word528",["当月用电量"])+":&nbsp;"}}</span>
							<!-- <span v-if="ActiveIndex==2"  :title="getLanguageStr('plant291','当季用电量')">{{getLanguageStr('plant291','当季用电量')}}：</span> -->
							<span v-if="ActiveIndex==2" :title="$t('word529',['当年用电量'])">{{$t("word529",["当年用电量"])+":&nbsp;"}}</span>
							<span v-if="ActiveIndex==3" :title="$t('word1049',['总用电量'])">{{$t("word1049",["总用电量"])+":&nbsp;"}}</span>
							<span v-if="detailData.statistics" :title="convertData(detailData.statistics.useValue,2,'k','Wh')[0]">{{ convertData(detailData.statistics.useValue,2,"k",'Wh')[0]}}</span>
							<span v-else>--</span>
						</div>
						<div class="progress mt05x">
							<div class="fL h10 bgPrimary transWidth" :style="{width:proportion.fromGenerationProportion+'%'}"></div>
							<div class="fR h10 bgSuccess transWidth" :style="{width:proportion.fromGridProportion+'%'}"></div>
						</div>
						<div class="cb">
							<div class="fL textL">
								<span class="cPrimary" v-if="detailData.statistics" :title="floatFix(detailData.statistics.useRatio,2,'%')">{{floatFix(detailData.statistics.useRatio,2,'%')}}</span>
								<span v-else>--</span><br>
								<span :title="getLanguageStr('word1767','来自发电')">{{getLanguageStr('word1767','来自发电')}}</span><br>
								<span v-if="detailData.statistics" :title="convertData(detailData.statistics.useValue*detailData.statistics.useRatio/100,2,'k','Wh')[0]">{{convertData(detailData.statistics.useValue*detailData.statistics.useRatio/100,2,"k","Wh")[0]}}</span>
								<span v-else>--</span>
							</div>
							<div class="fR textR">
								<span v-if="detailData.statistics" class="cSuccess" :title="floatFix(detailData.statistics.buyRatio,2,'%')">{{floatFix(detailData.statistics.buyRatio,2,'%')}}</span>
								<span v-else>--</span><br>
								<span :title="getLanguageStr('word1770','来自购电')">{{getLanguageStr('word1770','来自购电')}}</span><br>
								<span v-if="detailData.statistics" :title="convertData(detailData.statistics.useValue*detailData.statistics.buyRatio/100,2,'k','Wh')[0]">{{convertData(detailData.statistics.useValue*detailData.statistics.buyRatio/100,2,"k","Wh")[0]}}</span>
								<span v-else>--</span>
							</div>
						</div>
					</div>
				</div>
				<!-- 理论自发自用比例 -->
				<div class="w49pct" v-if="metering.consumeProportionStatisticMethod =='THEORY'">
					<div class="progressWrap w80pct">
						<div>
							<span v-if="ActiveIndex==0" :title="$t('word358',['当日发电量'])+':&nbsp;'">{{$t('word358',['当日发电量'])+':&nbsp;'}}</span>
							<span v-if="ActiveIndex==1" :title="$t('word359',['当月发电量'])+':&nbsp;'">{{$t('word359',['当月发电量'])+':&nbsp;'}}</span>
							<!-- <span v-if="ActiveIndex==2" :title="getLanguageStr('plant290','当季发电量')">{{getLanguageStr('plant290','当季发电量')}}</span> -->
							<span v-if="ActiveIndex==2" :title="$t('word360',['当年发电量'])+':&nbsp;'">{{$t('word360',['当年发电量'])+':&nbsp;'}}</span>
							<span v-if="ActiveIndex==3" :title="$t('word912',['总发电量'])+':&nbsp;'">{{$t('word912',['总发电量'])+':&nbsp;'}}</span>
							<span v-if="detailData.statistics"><span :title="convertData(detailData.statistics.generationValue,2,'k','Wh')[0]">{{convertData(detailData.statistics.generationValue,2,"k",'Wh')[0]}}</span></span>
							<span v-else>--</span>
						</div>
						<div class="progress">
								<div class="fL h10 bgPrimary transWidth" v-if="JSON.stringify(detailData) !='{}'" :style="{width:theoryConsumeProportion+'%'}"></div>
								<div class="fR h10 bgSuccess transWidth" v-if="JSON.stringify(detailData) !='{}'" :style="{width:loadedRight+'%'}"></div>
						</div>
						<div class="cb">
							<div class="fL textL">
								<span class="cPrimary" :title="floatFix(theoryConsumeProportion,2,'%')">{{floatFix(theoryConsumeProportion,2,'%')}}</span><br>
								<span :title="$t('word1760',['用于自用'])">{{$t('word1760',['用于自用'])}}</span><br>
								<span v-if="metering.theoryConsumeProportion">{{convertData(detailData.statistics.generationValue*theoryConsumeProportion/100,2,"k","Wh")[0]}}</span>
								<span v-else>--</span>
							</div>
							<div class="fR textR">
								<span class="cSuccess" :title="floatFix(loadedRight,2,'%')">{{floatFix(loadedRight,2,'%')}}</span><br>
								<span :title="$t('word1762',['用于并网'])">{{$t('word1762',['用于并网'])}}</span><br>
								<span v-if="metering.theoryConsumeProportion" :title="convertData(detailData.statistics.generationValue*(100-theoryConsumeProportion)/100,2,'k','Wh')[0]">{{convertData(detailData.generation*(100-theoryConsumeProportion)/100,2,"k","Wh")[0]}}</span>
								<span v-else>--</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="pb1x">
			<ChartLine id="chartLineExcess" :data="ChartData" :option="defChartMonthOption" :chartClass="'h28x'" v-if="ActiveIndex==0"></ChartLine>
			<ChartColumn id="chartColumnExcess" :data="ChartData" :option="defChartMonthOption" :chartClass="'h28x'" v-else></ChartColumn>
		</div>
		</div>
</template>

<script>
import Loading from '@/components/common/ui/Loading';
import ChartLine from '@/components/common/chart/ChartLine.vue';
import ChartColumn from '@/components/common/chart/ChartColumn.vue';
import DeviceDetailParam from '@/view/device/device/part/DeviceDetailParam';// 详情
import * as equipmentApi from '@/api/maintain/plant/list';
import * as lib from '@/util/lib.js';
import {getLocal} from '@/util';
import {getLanguageStr} from '@/util/language.js';
export default {
	name: 'generateHistoryExcess',
	components: {Loading, ChartLine, ChartColumn, DeviceDetailParam},
	computed: {
		timeGetTime () {
			let year = new Date(this.time).getFullYear();
			let month = new Date(this.time).getMonth() + 1;
			let day = new Date(this.time).getDate();
			if (this.ActiveIndex == 0) {
				return new Date(year + '/' + month + '/' + day).getTime();
			} else if (this.ActiveIndex == 1) {
				return new Date(year + '/' + month + '/01').getTime();
			} else if (this.ActiveIndex == 2) {
				return new Date(String(year)).getTime();
			}
		},
		todayGetTime () {
			// let year = new Date().getFullYear()
			// let month = new Date().getMonth() + 1
			// let day = new Date().getDate()
			// if (this.ActiveIndex == 0) {
			// 	return new Date(year + '/' + month + '/' + day).getTime()
			// } else if (this.ActiveIndex == 1) {
			// 	return new Date(year + '/' + month).getTime()
			// } else if (this.ActiveIndex == 2) {
			// 	return new Date(year).getTime()
			// }
			if (this.ActiveIndex == 0) {
			  return new Date(this.datepicker_Ctrl_day).getTime();
			} else if (this.ActiveIndex == 1) {
			  return new Date(this.datepicker_Ctrl_month).getTime();
			} else if (this.ActiveIndex == 2) {
			  return new Date(this.datepicker_Ctrl_year).getTime();
			}
		}
	},
	data () {
		return {
			ActiveIndex: 0,
			proportion: {
				toConsumptionProportion: 0, // 发电自用
				toGridProportion: 0, // 发电并网
				fromGenerationProportion: 0, // 来自发电
				fromGridProportion: 0// 来自并网
			},
			local: {},
			metering: [], // 记录图表时需要用到的数据，从vuex里获取会有顺序差，导致数据不准确
			isChart: true, // 图表数据是否加载完成
			theoryConsumeProportion: 0, // 理论自发自用率
			loadedRight: 0,
			time: new Date(),
			rangeDate: [new Date('2000'), new Date()],
			datepicker_Ctrl_day: '',
			datepicker_Ctrl_month: '',
			datepicker_Ctrl_year: '',
			timeChoose: [{
				datepicker: getLanguageStr('cmd93', '日'),
				format: 'YYYY/MM/DD',
				type: 'day'
			}, {
				datepicker: getLanguageStr('cmd95', '月'),
				format: 'YYYY/MM',
				type: 'month'
				// },{
				// 	datepicker:getLanguageStr("word1195","季度"),
				// 	format:'YYYY/MM',
				// 	type:'quarter'
			}, {
				datepicker: getLanguageStr('cmd96', '年'),
				format: 'YYYY',
				type: 'year'
			}, {
				datepicker: getLanguageStr('cmd97', '总'),
				format: 'YYYY',
				type: 'all'
			}],
			defChartMonthOption: {},
			ChartData: [], // 图标数据,
			detailData: {},
			chartList: [],
			assignInfo: {},
			stationId: null,
			systemId: null
			// yTitle:[]
		};
	},
	created () {
		this._getLocal();
	},
	methods: {
		getLanguageStr,
		floatFix: lib.floatFix,
		convertData: lib.convertData,
		show (data) {
			if (this.$parent.basicInfo.region) {
				let lastDay = lib.timeFormat(this.$parent.stationInfo.lastUpdateTime ? this.$parent.stationInfo.lastUpdateTime : new Date(), 'utc', '%Y/%m/%d', {offset: this.$parent.basicInfo.region.timezone});
				this.time = new Date(lastDay);

				this.datepicker_Ctrl_day = lastDay;
				this.datepicker_Ctrl_month = lib.timeFormat(this.time, 'utc', '%Y/%m/01');
				this.datepicker_Ctrl_year = lib.timeFormat(this.time, 'utc', '%Y');
			}
			this.stationId = data.stationId;
			this.systemId = data.systemId;
			if (data.assignInfo) {
				this.assignInfo = data.assignInfo;
			} else {
				this._getAssignInfo(data.stationId);
			}
			if (data.metering) {
				this.metering = data.metering;
			} else {
				this._getMetering(data.stationId);
			}
			this._showChart();
		},
		_getLocal () {
			this.local = getLocal();
		},
		disabledDate (time) {
			// let day = new Date().getTime()
			let day = new Date(this.datepicker_Ctrl_day).getTime();
			return day < time;
		},
		paramChooiceShow () {
			let chooseType = this.timeChoose[this.ActiveIndex].type;
	    	switch (chooseType) {
			     case 'month':
			        statistic('A13', 'A1339');
			        break;
			     case 'year':
			        statistic('A13', 'A1344');
			        break;
			         case 'all':
			        statistic('A13', 'A1349');
			        break;
			     default:
			       statistic('A13', 'A1334');
			}
			let cloneChart = _.cloneDeep(this.chartList);
			cloneChart.forEach(el => {
				el.isBeingSelected = el.default;
			});
			this.$refs.DeviceDetailParam.show(_.cloneDeep(this.chartList), cloneChart, true);
		},
		 leave () {
			this.paramChooiceActive = false;
			this.$refs.DeviceDetailParam.showParam = false;
		},
			 // 保持参数选择
		beingParamArray (data) {
			this.chartList = [];
			this.chartList = data;
		},
		// 参数选择
		updateShowParamArray (data) {
			this.chartList = [];
			this.chartList = data;
			if (this.ActiveIndex == 0) {
				this._getDayData();
			} else if (this.ActiveIndex == 1) {
				this._getMonthData();
			} else if (this.ActiveIndex == 2) {
				this._getYearData();
			} else {
				this._getTotalData();
			}
		},
		// 时区转换成毫秒
		mz () {
			return stage.time.timezoneMap[this.assignInfo.region.timezone].offset * 1000;
		},
		// 获取指定电站信息
		_getAssignInfo (id) {
			this.isAssign = true;
			equipmentApi.StationBasicInfo(id).then(response => {
				this.assignInfo = response;
			}, error => {
				this.isAssign = false;
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		// 获取理论自发自用率
		_getMetering (id) {
			equipmentApi.StationMetering(id).then(response => {
				this.metering = response;
				this.theoryNum(); // 获取理论自发自用比例并计算
			}, error => {
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		// 日历
		dateChange (str) {
			// type day(日) week(周) month(月) year(年) all(总)
			let type = this.timeChoose[this.ActiveIndex].type;
			let val = this.$refs.date.text;
			// var date=new Date(val);
			// let today = `${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`
			// let month = `${new Date().getFullYear()}/${new Date().getMonth() + 1}`
			// let year = `${new Date().getFullYear()}`
			// if(new Date(val).getTime()<new Date(today).getTime()){
			var date = new Date(type == 'month' || type == 'quarter' ? val.split('~').pop() + '/01' : val.split('~').pop());
			let step;
			switch (type) {
			case 'day':
				if (str === 'perv') {
					statistic('A13', 'A1336');
					step = -1;
				} else if (str === 'next' && new Date(val).getTime() < new Date(this.datepicker_Ctrl_day).getTime()) {
					statistic('A13', 'A1338');
					step = 1;
				} else {
					step = 0;
				}
				// var step = str === 'next'&&new Date(val).getTime()<new Date(this.datepicker_Ctrl_day).getTime() ? 1: -1
				date.setDate(date.getDate() + step);
				this.$refs.date.selectOk(date);
				break;
			case 'month':
				val += '/01'; // Firefox的new Date不能解析月格式 “2019/10”，需要加日期 01
				if (str === 'perv') {
					statistic('A13', 'A1341');
					step = -1;
				} else if (str === 'next' && new Date(val).getTime() < new Date(this.datepicker_Ctrl_month).getTime()) {
					statistic('A13', 'A1343');
					step = 1;
				} else {
					step = 0;
				}
				date.setMonth(date.getMonth() + step);
				this.$refs.date.selectOk(date);
				break;
			case 'quarter':
				if (str === 'perv') {
					step = -1;
				} else if (str === 'next' && new Date(val).getTime() < new Date(this.datepicker_Ctrl_day).getTime()) {
					step = 1;
				} else {
					step = 0;
				}
				this.curQuarter = Math.ceil((date.getMonth() + 1 + step) / 3);
				date.setMonth(date.getMonth() + step);
				this.$refs.date.selectOk(date);
				break;
			case 'year':
				if (str === 'perv') {
					statistic('A13', 'A1346');
					step = -1;
				} else if (str === 'next' && new Date(val).getTime() < new Date(this.datepicker_Ctrl_year).getTime()) {
					statistic('A13', 'A1348');
					step = 1;
				} else {
					step = 0;
				}
				date.setFullYear(date.getFullYear() + step);
				this.$refs.date.selectOk(date);
				break;
			default:
				break;
			}
		},
		// 获取天数
		_getCountDays () {
			let curDate = _.cloneDeep(this.time);
			// let curMonth =curDate.getMonth()
			// curDate.setMonth(curMonth+1)
			// curDate.setDate(0);
			// return curDate.getDate()
			let curMonth = curDate.getMonth() + 1;
			let curYear = curDate.getFullYear();
			return new Date(curYear, curMonth, 0).getDate();
		},
		// 曲线图
		_showChart () {
			this.detailData = {};
			// this.isChart=true
			this.$refs.Loading.show();
			this.chartList = {};
			this.theoryConsumeProportion = 0;
			this.loadedRight = 0;
			for (let attr in this.proportion) {
				this.proportion[attr] = 0;
			}
			// 日曲线图
			if (this.ActiveIndex == 0) { // 日
				this.chartList = [
					{
						name: getLanguageStr('word176', '发电功率'),
						type: 'generationPower',
						selected: true,
						default: true,
						isBeingSelected: true,
						unit: 'W',
						data: []
					}, {
						name: getLanguageStr('word977', '用电功率'),
						type: 'usePower',
						selected: true,
						unit: 'W',
						default: true,
						isBeingSelected: true,
						data: []
					}, {
						name: getLanguageStr('word177', '并网功率'),
						type: 'gridPower',
						selected: false,
						default: false,
						unit: 'W',
						data: []
					},
					 {
						name: getLanguageStr('word168', '购电功率'),
						type: 'buyPower',
						selected: false,
						default: false,
						unit: 'W',
						data: []
					}
					//  {
					// 	name:getLanguageStr("word1524","分时自发自用量"),
					// 	type:'gridPower',
					// 	selected:true,
					// 	default:true,
					// 	unit:"kWh",
					//     data:[]
					// }
				];
				this._chartDay();
			} else if (this.ActiveIndex == 1) { // 月图标
				let dateNum = this._getCountDays();
				this.chartList = [
					{
						name: getLanguageStr('word358', '当日发电量'),
						type: 'generationValue',
						selected: true,
						default: true,
						isBeingSelected: true,
						unit: 'kWh',
						data: new Array(dateNum)
					}, {
						name: getLanguageStr('word527', '当日用电量'),
						type: 'useValue',
						selected: true,
						isBeingSelected: true,
						unit: 'kWh',
						default: true,
						data: new Array(dateNum)
					}, {
						name: getLanguageStr('word501', '当日并网量'),
						type: 'gridValue',
						selected: false,
						default: false,
						unit: 'kWh',
						data: new Array(dateNum)
					},
					{
						name: getLanguageStr('word502', '当日购电量'),
						type: 'buyValue',
						selected: false,
						default: false,
						unit: 'kWh',
						data: new Array(dateNum)
					}
					// {
					// 	name:getLanguageStr("word1772","当日自发自用量"),
					// 	type:'fullPowerHoursDay',
					// 	selected:true,
					// 	default:true,
					// 	unit:"kWh",
					// 	data:new Array(dateNum)
					// }
				];
				this._chartMonth();
			} else if (this.ActiveIndex == 2) { // 年
				this.chartList = [
					{
						name: getLanguageStr('word359', '当月发电量'),
						type: 'generationValue',
						selected: true,
						isBeingSelected: true,
						default: true,
						unit: 'kWh',
						data: new Array(12)
					}, {
						name: getLanguageStr('word528', '当月用电量'),
						type: 'useValue',
						selected: true,
						isBeingSelected: true,
						unit: 'kWh',
						default: true,
						data: new Array(12)
					}, {
						name: getLanguageStr('word503', '当月并网量'),
						type: 'gridValue',
						selected: false,
						default: false,
						unit: 'kWh',
						data: new Array(12)
					},
					{
						name: getLanguageStr('word504', '当月购电量'),
						type: 'buyValue',
						selected: false,
						default: false,
						unit: 'kWh',
						data: new Array(12)
					}
					// {
					// 	name:getLanguageStr("word1773","当月自发自用量"),
					// 	type:'fullPowerHoursDay',
					// 	selected:true,
					// 	default:true,
					// 	unit:"kWh",
					// 	data:new Array(12)
					// }
				];
				this._chartYear();
			} else if (this.ActiveIndex == 3) { // 总
				this._totalData();
			}
		},
		theoryNum () {
			this.$nextTick(() => {
				if (this.metering.consumeProportionStatisticMethod == 'THEORY' && this.assignInfo.gridInterconnectionType == 'EXCESS') {
					if (this.metering.theoryConsumeProportion && this.detailData.statistics) {
						if (this.detailData.statistics.generationValue == 0 || !this.detailData.statistics.generationValue) {
							this.theoryConsumeProportion = 0;
							this.loadedRight = 0;
						} else {
							this.theoryConsumeProportion = this.metering.theoryConsumeProportion;
							this.loadedRight = 100 - this.metering.theoryConsumeProportion;
						}
					} else {
						this.theoryConsumeProportion = null;
						this.loadedRight = null;
					}
				}
			});
		},
		_setFinalData () {
			let yTitle = [];
			this.yTitle = [];
			this.ChartData.forEach(index => {
				yTitle.push(this.ChartData[index].unit);
				delete this.ChartData[index].default;
				delete this.ChartData[index].selected;
				delete this.ChartData[index].type;
			});
			this.yTitle = _.uniq(yTitle);
		},
		_getDayData () {
			let chartData = [];
			chartData = _.cloneDeep(this.chartList).filter(el => el.selected == true);
			for (let attr in chartData) {
				chartData[attr].data = [];
				if (this.detailData.records.length) {
					this.detailData.records.forEach((val, index) => {
						if (val[chartData[attr].type] != null)chartData[attr].data.push([val.dateTime * 1000 + this.mz(), val[chartData[attr].type]]);
					});
					chartData[attr].data = lib.sortData(chartData[attr].data, {byKey: 0});
				}
			}
			this.ChartData = chartData;
			let yTitle = [];
			for (let attr in this.ChartData) {
				yTitle.push(this.ChartData[attr].unit);
				// if(attr>0){
				// 	this.ChartData[attr].yAxis=Number(attr)
				// }
				delete this.ChartData[attr].default;
				delete this.ChartData[attr].selected;
				delete this.ChartData[attr].type;
			}
			this.defChartMonthOption = (function () { // 默认月图表参数
				let obj = { // d
					yTitle: _.uniq(yTitle),
					opposite: true
				};
				return obj;
			}());
		},
		// 日图表数据
		_chartDay () {
			lib.loadingChange($('#chartLineExcess [Loading]'), true);
			let chooseDay = {
				'year': this.time.getFullYear(),
				'month': this.time.getMonth() + 1,
				'day': this.time.getDate()
			};
			// equipmentApi.cancelRequest()
			equipmentApi.PowerDayHistory(this.stationId, chooseDay).then(response => {
				this.ChartData = [];
				lib.loadingChange($('#chartLineExcess [Loading]'), false);
				this.$refs.Loading.hide();
				this.detailData = response;
				this.theoryNum();
				if (response.records.length == 0) {
					this.ChartData = [];
				} else {
					if (response.statistics) {
						let {generationRatio, gridRatio, useRatio, buyRatio} = response.statistics;
						setTimeout(() => {
							this.proportion = {
								'toConsumptionProportion': generationRatio,
								'toGridProportion': gridRatio,
								'fromGenerationProportion': useRatio,
								'fromGridProportion': buyRatio
							};
						}, 20);
					}
					this._getDayData();
				}
			}, error => {
				lib.loadingChange($('#chartLineExcess [Loading]'), false);
				this.$refs.Loading.hide();
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		_getMonthData () {
			let dateNum = this._getCountDays();
			let chartData = [];
			chartData = _.cloneDeep(this.chartList).filter(el => el.selected == true);
			for (let attr in chartData) {
				chartData[attr].data = new Array(dateNum);
				$.each(chartData[attr].data, (index) => {
					chartData[attr].data[index] = null;
				});
				if (this.detailData.records.length) {
					this.detailData.records.map((val, index) => {
						chartData[attr].data[parseInt(val.day) - 1] = Number(val[chartData[attr].type]);
					});
				}
			}
			this.ChartData = chartData;
			for (let attr in this.ChartData) {
				delete this.ChartData[attr].default;
				delete this.ChartData[attr].selected;
				delete this.ChartData[attr].type;
			}
			this.defChartMonthOption = (function () { // 默认月图表参数
				let obj = { // d
					yTitle: ['kWh'],
					timeType: 'month',
					xCategories: new Array(dateNum)
				};
				$.each(obj.xCategories, function (index) {
					obj.xCategories[index] = index + 1;
				});
				return obj;
			}());
		},
		// 月图表数据
		_chartMonth () {
			lib.loadingChange($('#chartColumnExcess [Loading]'), true);
			let chooseMonth = {
				'year': this.time.getFullYear(),
				'month': this.time.getMonth() + 1
			};
			// equipmentApi.cancelRequest()
			equipmentApi.PowerMonthHistory(this.stationId, chooseMonth).then(response => {
				if (this.timeChoose[this.ActiveIndex].type == 'month') {
					this.ChartData = [];
					lib.loadingChange($('#chartColumnExcess [Loading]'), false);
					this.$refs.Loading.hide();
					if (!response) return;
					if (response.statistics) {
						let {generationRatio, gridRatio, useRatio, buyRatio} = response.statistics;
						setTimeout(() => {
							this.proportion = {
								'toConsumptionProportion': generationRatio,
								'toGridProportion': gridRatio,
								'fromGenerationProportion': useRatio,
								'fromGridProportion': buyRatio
							};
						}, 20);
					}
					this.detailData = response;
					this.theoryNum();
					if (this.detailData.records.length == 0) {
						this.ChartData = [];
					} else {
						this._getMonthData();
					}
				}
			}, error => {
				lib.loadingChange($('#chartColumnExcess [Loading]'), false);
				this.$refs.Loading.hide();
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		// 季度图表
		_charQuarter () {
			lib.loadingChange($('#chartColumn [Loading]'), true);
			let chooseQuarter = {
				year: lib.timeFormat(this.time, 'utc', '%Y'),
				quarter: this.curQuarter
			};
			// equipmentApi.cancelRequest()
			equipmentApi.PowerQuarterHistory(this.stationId, chooseQuarter.year, chooseQuarter.quarter).then(response => {
				this.ChartData = [];
				this.$refs.Loading.hide();
				if (!response) return;
				let {generationRatio, gridRatio, useRatio, buyRatio} = response.statistics;
				setTimeout(() => {
					this.proportion = {
						'toConsumptionProportion': generationRatio,
						'toGridProportion': gridRatio,
						'fromGenerationProportion': useRatio,
						'fromGridProportion': buyRatio
					};
				}, 20);
				lib.loadingChange($('#chartColumn [Loading]'), false);
				this.detailData = response;
				this.theoryNum();
				if (this.detailData.data.length == 0) {
					this.ChartData = [];
				} else {
					let n = (this.curQuarter - 1) * 3 + 1;
					for (let attr in this.chartList) {
						$.each(this.chartList[attr].data, (index) => {
							this.chartList[attr].data[index] = null;
						});
						this.detailData.data.map((val, index) => {
							this.chartList[attr].data[parseInt(val.date) - n] = Number(val[attr]);
						});
						this.ChartData.push(this.chartList[attr]);
					}
					this.defChartMonthOption = (function () { // 默认月图表参数
						let obj = {
							yTitle: ['kWh', 'CNY', 'h'],
							timeType: 'quarter',
							opposite: true,
							xCategories: new Array(3)
						};
						$.each(obj.xCategories, function (index) {
							obj.xCategories[index] = n + index;
						});
						return obj;
					}());
				}
			}, error => {
				lib.loadingChange($('#chartColumn [Loading]'), false);
				this.$refs.Loading.hide();
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		_getYearData () {
			// let dateNum=this._getCountDays()
			let chartData = [];
			chartData = _.cloneDeep(this.chartList).filter(el => el.selected == true);
			for (let attr in chartData) {
				chartData[attr].data = new Array(12);
				$.each(chartData[attr].data, (index) => {
					chartData[attr].data[index] = null;
				});
				if (this.detailData.records.length) {
					this.detailData.records.map((val, index) => {
						chartData[attr].data[parseInt(val.month) - 1] = Number(val[chartData[attr].type]);
					});
				}
			}
			this.ChartData = chartData;
			for (let attr in this.ChartData) {
				delete this.ChartData[attr].default;
				delete this.ChartData[attr].selected;
				delete this.ChartData[attr].type;
			}
			this.defChartMonthOption = (function () { // 默认月图表参数
				let obj = { // d
					yTitle: ['kWh'],
					timeType: 'year',
					xCategories: new Array(12)
				};
				$.each(obj.xCategories, function (index) {
					obj.xCategories[index] = index + 1;
				});
				return obj;
			}());
		},
		// 年图表数据
		_chartYear () {
			lib.loadingChange($('#chartColumnExcess [Loading]'), true);
			let chooseYear = {
				'year': this.time.getFullYear()
			};
			// equipmentApi.cancelRequest()
			equipmentApi.PowerYearHistory(this.stationId, chooseYear).then(response => {
				if (this.timeChoose[this.ActiveIndex].type == 'year') {
					this.ChartData = [];
					this.$refs.Loading.hide();
					if (!response) return;
					if (response.statistics) {
						let {generationRatio, gridRatio, useRatio, buyRatio} = response.statistics;
						setTimeout(() => {
							this.proportion = {
								'toConsumptionProportion': generationRatio,
								'toGridProportion': gridRatio,
								'fromGenerationProportion': useRatio,
								'fromGridProportion': buyRatio
							};
						}, 20);
					}
					lib.loadingChange($('#chartColumnExcess [Loading]'), false);
					this.detailData = response;
					this.theoryNum();
					if (this.detailData.records.length == 0) {
						this.ChartData = [];
					} else {
						this._getYearData();
						// for(let attr in this.chartList){
						// 	$.each(this.chartList[attr].data,(index)=>{
						// 		this.chartList[attr].data[index]=null
						// 	})
						// 	this.detailData.records.map((val,index)=>{
						// 		this.chartList[attr].data[parseInt(val.day)-1]=Number(val[attr])
						// 	})
						// 	this.ChartData.push(this.chartList[attr])
						// }
						// this.defChartMonthOption=function(){//默认月图表参数
						// 	let obj={ //d
						// 		yTitle:['kWh'],
						// 		timeType:"year",
						// 		// opposite:true,
						// 		xCategories:new Array(12)
						// 	}
						// 	$.each(obj.xCategories,function(index){
						// 		obj.xCategories[index]=index+1;
						// 	});
						// 	return obj;
						// }()
					}
				}
			}, error => {
				!_.isEmpty(error) && this.$notify(error);
				lib.loadingChange($('#chartColumnExcess [Loading]'), false);
				this.$refs.Loading.hide();
			});
		},
		_getTotalData () {
			let startYear = [];
			for (let attr in this.detailData.records) {
				startYear.push(this.detailData.records[attr].year);
			}
			startYear = lib.sortData(startYear)[0]; // 获取最小的年份
			let endYear = lib.timeFormat(new Date(), 'inc', '%Y'); // 获取当年年份
			let YearNum = Number(endYear) - Number(startYear) + 1; // X轴总数
			this.rangeDate = [new Date(String(startYear)), new Date(endYear)];

			let chartData = [];
			chartData = _.cloneDeep(this.chartList).filter(el => el.selected == true);
			for (let attr in chartData) {
				chartData[attr].data = new Array(YearNum);
				$.each(chartData[attr].data, (index) => {
					chartData[attr].data[index] = null;
				});
				this.detailData.records.map((val, index) => {
					chartData[attr].data[parseInt(val.year) - Number(startYear)] = Number(val[chartData[attr].type]);
				});
			}
			this.ChartData = chartData;
			for (let attr in this.ChartData) {
				delete this.ChartData[attr].default;
				delete this.ChartData[attr].selected;
				delete this.ChartData[attr].type;
			}
			this.defChartMonthOption = (function () { // 默认月图表参数
				let obj = { // d
					yTitle: ['kWh'],
					timeType: 'all',
					// opposite:true,
					xCategories: new Array(YearNum)
				};
				$.each(obj.xCategories, function (index) {
					obj.xCategories[index] = index + Number(startYear);
				});
				return obj;
			}());
		},
		// 总图表数据
		_totalData () {
			lib.loadingChange($('#chartColumnExcess [Loading]'), true);
			let chooseTotal = {
				'startYear': 2000,
				'endYear': this.time.getFullYear()
			};
			// equipmentApi.cancelRequest()
			equipmentApi.PowerTotalHistory(this.stationId, chooseTotal).then(response => {
				if (this.timeChoose[this.ActiveIndex].type == 'all') {
					lib.loadingChange($('#chartColumnExcess [Loading]'), false);
					this.$refs.Loading.hide();
					if (!response) return;
					if (response.statistics) {
						let {generationRatio, gridRatio, useRatio, buyRatio} = response.statistics;
						setTimeout(() => {
							this.proportion = {
								'toConsumptionProportion': generationRatio,
								'toGridProportion': gridRatio,
								'fromGenerationProportion': useRatio,
								'fromGridProportion': buyRatio
							};
						}, 20);
					}
					this.detailData = response;
					this.theoryNum();
					if (this.detailData.records.length == 0) {
						this.ChartData = [];
					} else {
						let startYear = [];
						for (let attr in response.records) {
							startYear.push(this.detailData.records[attr].year);
						}
						startYear = lib.sortData(startYear)[0]; // 获取最小的年份
						let endYear = lib.timeFormat(new Date(), 'inc', '%Y'); // 获取当年年份
						let YearNum = Number(endYear) - Number(startYear) + 1; // X轴总数
						this.rangeDate = [new Date(String(startYear)), new Date(endYear)];
						this.chartList = [
							{
								name: getLanguageStr('word360', '当年发电量'),
								type: 'generationValue',
								selected: true,
								default: true,
								isBeingSelected: true,
								unit: 'kWh',
								data: new Array(YearNum)
							}, {
								name: getLanguageStr('word529', '当年用电量'),
								type: 'useValue',
								selected: true,
								isBeingSelected: true,
								unit: 'kWh',
								default: true,
								data: new Array(YearNum)
							}, {
								name: getLanguageStr('word505', '当年并网量'),
								type: 'gridValue',
								selected: false,
								default: false,
								unit: 'kWh',
								data: new Array(YearNum)
							},
							{
								name: getLanguageStr('word506', '当年购电量'),
								type: 'buyValue',
								selected: false,
								default: false,
								unit: 'kWh',
								data: new Array(YearNum)
							}
							// {
							// 	name:getLanguageStr("word1774","当年自发自用量"),
							// 	type:'fullPowerHoursDay',
							// 	selected:true,
							// 	default:true,
							// 	unit:"kWh",
							// 	data:new Array(YearNum)
							// }
						];
						this._getTotalData();
					}
				}
			}, error => {
				lib.loadingChange($('#chartColumnExcess [Loading]'), false);
				!_.isEmpty(error) && this.$notify(error);
				this.$refs.Loading.hide();
			});
		},
		_timePicker (item, index) {
			this.$refs.DeviceDetailParam.showParam = false;
			this.ActiveIndex = index;
			this._showChart();
		}
	}

};
</script>

<style lang="scss" scoped>
.clearfix::after{
	content: "";
	clear: both;
	display: block
}
.datepicker{
		width: 125px !important;
		height: 2.2em;
		line-height: 2.2em;
}
.progressWrap{
	margin:.5em auto 1em;
	>div{
		display: block;
		line-height: 1.5em
	}
	>.cb{
		padding-top: 0.3em;
		.cBlue{color:#00a8ff}
		.cGreen{color:#1fea37}
	}
	.progress{
		height: 1em;
		overflow: hidden;
		border-radius: .5em;
		border:1px solid rgba(0, 0, 0, 0.1);
		>div{
			display: inline-block;

		}
		.h10{
			height: 100%;
		}

	}
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/GenerateHistoryExcess.vue